Ext.define('SA.Sidebar', {
    alias: 'widget.sidebar',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-sidebar',
    itemId: 'sidebar',
    occupiesWidth: 315,
    width: 315,

    items: [
        {
            xtype: 'component',
            cls: 'sa-empty-sidebar-mask',
            hidden: true,
            itemId: 'mask'
        }, {
            xtype: 'sidebar-tabs'
        }, {
            xtype: 'sidebar-panels'
        }
    ],

    initComponent() {
        this.lastClickedTab = null;
        this.tabMouseOverListener = null;
        this.sidebarCollapsed = false; 

        this.logo = new SA.SidebarLogo();
        this.collapseBtn = Ext.widget({xtype: 'sidebar-collapse-button', renderTo: Ext.getBody()});

        this.callParent();

        this.mask = this.down('#mask');
        this.tabs = this.down('sidebar-tabs');
        this.panels = this.down('sidebar-panels');
    },

    animateMove(duration, cb) {
        var me = this,
            start = this.lastAnimation = performance.now();

        requestAnimationFrame(frame);

        function frame(time) {
            if (start !== me.lastAnimation) {
                return;
            }

            var elapsed = Math.min(time - start, duration),
                proportion = elapsed / duration;

            proportion = proportion < 0.5 ? 2 * proportion * proportion : ((4 - 2 * proportion) * proportion - 1);

            cb.call(me, proportion);

            Ext.EventManager.idleEvent.fire();

            if (elapsed !== duration) {
                requestAnimationFrame(frame);
            }
        }
    },

    clearTabMouseOverListener() {
        this.setTabMouseOverListener(null);
    },

    collapse() {
        this.sidebarCollapsed = true;

        this.animateMove(200, this.collapseAnimation);

        this.logo.useDark();
        this.collapseBtn.setCollapsed(true);
    },

    collapseAnimation(proportion) {
        var width = this.width,
            position = (width + 10) * proportion << 0,
            transform = 'translateX(-' + position + 'px)',
            visibility = proportion === 1 ? 'hidden' : 'visible';

        this.el.setStyle({transform, visibility});

        this.occupiesWidth = Math.max(0, width - position);

        this.fireEvent('resize');
    },

    expand() {
        this.sidebarCollapsed = false;

        this.el.setStyle('visibility', 'visible');

        this.animateMove(200, this.expandAnimation);

        this.logo.useLight();
        this.collapseBtn.setCollapsed(false);
    },

    expandAnimation(proportion) {
        proportion = 1 - proportion;

        var width = this.width,
            position = (width + 10) * proportion << 0;

        this.el.setStyle({transform: 'translateX(-' + position + 'px)'});

        this.occupiesWidth = Math.max(0, width - position);

        this.fireEvent('resize');
    },

    fireUseItem(event, item) {
        this.fireEvent(event, item);
    },

    getDataBrowseOrSearchWindowResultAttributeIds() {
        return this.panels.getDataPanel().getBrowseOrSearchWindowResultAttributeIds();
    },

    getLastClickedTab() {
        return this.lastClickedTab;
    },

    getWidth() {
        return this.occupiesWidth;
    },

    hasSelectedTab() {
        return this.tabs.hasSelectedTab();
    },

    hideMask() {
        this.setMaskVisible(false);
    },

    hideToolbarTabs() {
        SA.ProjectViewToolbar.hideTabs();
    },

    initEvents() {
        this.callParent();

        this.collapseBtn.on('click', this.onCollapseBtnClick, this);
        this.tabs.on('click:tab', this.onTabClick, this);
        this.tabs.on('mouseover:tab', this.onTabMouseOver, this);

        SA.data.UserDatasets.on('delete', this.refreshDataPanel, this);
        SA.data.UserDatasets.on('rename', this.refreshDataPanel, this);
    },

    lastClickedLocationsTab() {
        return this.getLastClickedTab() === 'locations';
    },

    onCollapseBtnClick() {
        this.sidebarCollapsed ? this.expand() : this.collapse();
    },

    onTabClick(type) {
        this.lastClickedTab = type;
        this.setSelectedTab(type);
    },

    onTabMouseOver(tab) {
        this.tabMouseOverListener?.(tab);
    },

    openDataFolder(attribute) {
        this.panels.getDataPanel().openDataFolder(attribute);
    },

    refreshDataPanel() {
        this.panels.refreshDataPanel();
    },

    setEnabledTabs(tabs) {
        this.tabs.setEnabledTypes(tabs);
        SA.ProjectViewToolbar.setEnabledTabs(tabs);
    },

    setHandlers(handlers) {
        this.panels.setHandlers(handlers);
    },

    setMaskVisible(visible) {
        this.mask.setVisible(visible);
    },

    setModel(model) {
        this.panels.setModel(model);
    },

    setSelectedTab(tab) {
        this.tabs.setSelectedType(tab);
        this.panels.setSelectedType(tab);
    },

    setTabMouseOverListener(listener) {
        this.tabMouseOverListener = listener;
    },

    setUseAttributeHandler(handler) {
        this.panels.setUseAttributeHandler(handler);
    },

    setUseLocationHandler(handler) {
        this.panels.setUseLocationHandler(handler);
    },

    showMask() {
        this.setMaskVisible(true);
    },

    showToolbarTabs() {
        SA.ProjectViewToolbar.showTabs();
    }
});
